import { render, staticRenderFns } from "./Lifestyle.vue?vue&type=template&id=c689c4da&"
import script from "./Lifestyle.vue?vue&type=script&lang=js&"
export * from "./Lifestyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports